
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDataService } from './shared/inmemory-db/inmemory-db.service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TokenInterceptorService } from './shared/services/token-interceptor.service';
import { ErrorInterceptor } from './shared/services/error-interceptor';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { TenantService } from './shared/services/Tenant.service';
import { GlobalDataService } from './shared/services/globalData.service';

// import { BoldReportViewerModule } from '@boldreports/angular-reporting-components';
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/common/bold.reports.common.min';
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/common/bold.reports.widgets.min';
// // Report viewer
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/bold.report-viewer.min';




export function TranslationLoaderFactory(http: HttpClient) {
  // return new TranslateHttpLoader(http);
}

export class SentenceCaseMissingTranslation implements MissingTranslationHandler {
  handle({ key }: MissingTranslationHandlerParams): string {
    const text = key.replace(/_/g, ' ');
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}

export function checkTenantFactory(tenantService: TenantService, router: Router,globalDataService:GlobalDataService): () => Promise<void> {
  return (): Promise<void> => {
    if (!environment.production) {
      return Promise.resolve(); // Skip the check in development mode
    }

    // const subdomain = 'Default';
    const subdomain = window.location.hostname.split('.')[0];
    if(subdomain !=globalDataService.getCurrentTanantName()){
      
      return tenantService.checkTenantAvailability(subdomain).toPromise().then((available) => {
        
        if (!available) {
          router.navigate(['/site-not-available']); // Redirect to "site not available" page
        }
      }).catch(() => {
        router.navigate(['/site-not-available']);
      });

    }else{
      return Promise.resolve(); // Skip the tenant check if it has already been done
    }

  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    InMemoryWebApiModule.forRoot(InMemoryDataService, { passThruUnknownUrl: true }),
    AppRoutingModule ,
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // })
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useFactory: TranslationLoaderFactory, deps: [HttpClient] },
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: SentenceCaseMissingTranslation }
    }),
    // BoldReportViewerModule
  ],
  // providers: [
  //   {
  //     provide: HTTP_INTERCEPTORS,
  //     useClass: TokenInterceptorService,
  //     multi: true
  //   },
  //   {
  //     provide: HTTP_INTERCEPTORS,
  //     useClass: ErrorInterceptor,
  //     multi: true
  //   },
  // ],
  providers: [
    TenantService,
    GlobalDataService,
    ...(environment.production ? [{
      provide: APP_INITIALIZER,
      useFactory: checkTenantFactory,
      deps: [TenantService, Router, GlobalDataService],
      multi: true
    }] : []),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
     {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
    // DatePipe,
    // PermissionService,
    // VirtualKeyBoardService,
    // CustomUserStoreService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
